<template>
    <v-container fluid>
        <div>
            <v-row>
                <v-col class="pl-5">
                    <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="lockClick(null)">
                        <v-icon small>fa-lock</v-icon>&nbsp;{{ $t('buttons.lock') }}
                    </v-btn>
                    <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                        <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-row> </v-row>
        </div>
        <v-row>
            <v-col cols="12">
                <div v-for="(value, index) in salaries" :key="index">
                    <PlacementSalaryTable :inEditMode="inEditMode" :reload="reload" :salary="value" />
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PlacementSalaryTable from './PlacementSalaryTable.vue';

export default {
    name: 'SeafarerPlacementSalary',
    components: {PlacementSalaryTable},
    data: function () {
        return {
            initialLoad: false,
            lockKey: 'placement-salary',
            lockTimer: null,
            salaries: [],
            placement: null,
        };
    },
    props: ['placementId', 'inEditMode', 'reload'],
    methods: {
        reloadData() {
            let vm = this;
            this.$APICall('get', 'salaries/' + this.placementId, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data.items));
                    vm.salaries = usableData;
                }
            });
        },
        lockClick() {
            this.$emit('edit');
        },
        editClick() {
            this.$emit('edit');
        },
        removeLock() {
            let vm = this;
            vm.$emit('edit');
            clearInterval(vm.lockTimer);
            if (this.placement != null) {
                this.$removeLock(this, this.lockKey + '|' + this.placement.id);
            }
        },
        backClick() {
            this.$router.go(-1);
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.inEditMode) {
            let vm = this;
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    if (vm.lockTimer !== null) clearInterval(this.lockTimer);
                    vm.removeLock();
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            next(true);
        }
    },
    mounted() {
        let vm = this;
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        } else {
            this.$APICall('get', 'placements/' + this.placementId, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data.item));
                    vm.placement = usableData;
                    let userId = this.$myStore.state.user.id;
                    vm.$APICall('get', 'generate-timesheet/' + vm.placementId, {userId}, (data, success) => {
                        if (!success) {
                            vm.$alert(vm.$t('alerts.generatingTimesheetError'));
                        } else {
                            vm.reloadData();
                        }
                    });
                }
            });
        }
    },
};
</script>

<style scoped></style>
